export default {
      id: "icon-apps-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-apps",
      toString: function () {
        return this.url;
      }
    }